import {StyleSheet} from "aphrodite";

import {DetailCell} from "@khanacademy/wonder-blocks-cell";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {
    HeadingSmall,
    HeadingXSmall,
} from "@khanacademy/wonder-blocks-typography";

type Props = {
    title: string;
    stepLabel?: string;
};

const InstructionsTitleCell = ({title, stepLabel}: Props) => {
    return (
        <DetailCell
            title={
                <HeadingSmall tag="h4" style={styles.title}>
                    {title}
                </HeadingSmall>
            }
            styles={{root: styles.titleCell}}
            horizontalRule="full-width"
            subtitle1={
                stepLabel && (
                    <HeadingXSmall tag="h3" style={styles.stepLabel}>
                        {stepLabel}
                    </HeadingXSmall>
                )
            }
        />
    );
};

const styles = StyleSheet.create({
    stepLabel: {
        alignSelf: "center",
        display: "flex",
        maxWidth: "100%",
        color: color.offBlack64,
    },
    title: {
        fontSize: 18,
        textAlign: "center",
    },
    titleCell: {
        backgroundColor: color.offWhite,
    },
});

export default InstructionsTitleCell;
